(() => {
  if (customElements.get('pinterest-button-filter')) return;

  class PinterestButtonFilter extends HTMLElement {
    constructor() {
      super();
      this.onMutation = this.onMutation.bind(this);
    }

    connectedCallback() {
      let enabledPaths = [];

      try {
        enabledPaths = JSON.parse(this.dataset.enabledPaths || '[]');
      } catch {
        return;
      }

      const currentPath = this.normalizePath(window.location.pathname);
      const allowedPaths = enabledPaths.map((path) => this.normalizePath(path));
      
      if (allowedPaths.includes(currentPath)) return;
      this.removePinterestButtons();

      this.observer = new MutationObserver(this.onMutation);
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    normalizePath(path) {
      let normalized = (path || '').trim();

      if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
        try {
          normalized = new URL(normalized).pathname;
        } catch {
          return '/';
        }
      }

      normalized = normalized.replace(/\/$/, '');
      return normalized || '/';
    }

    removePinterestButtons(root = document) {
      root.querySelectorAll('.rapi-button').forEach((button) => {
        button.remove();
      });
    }

    onMutation(mutations) {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('.rapi-button')) {
            node.remove();
            return;
          }

          this.removePinterestButtons(node);
        });
      });
    }
  }

  customElements.define('pinterest-button-filter', PinterestButtonFilter);
})();
